import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { TextValue } from '../../entity/conditionvalue/textvalue';
import { QueryCondition } from '../../entity/querycondition';

export class TextHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const tv = (qc.value as TextValue);
        return Object.keys(tv).length > 0 && tv.value ? [{
            'FilterField' : qc.fieldCode,
            'Compare' : CompareType.Like, //like CompareType.like undefined
            'Value' : tv.value,
            'Relation' : RelationType.And, //and undefined
            'Expresstype':ValueType.Value
        }] : [];
    }
}